import React from "react";
import { Link } from "react-router-dom";
import { LockKeyhole, ArrowRight } from "lucide-react";

const GREEN = "#84ff00";

export default function EntitlementGate({
  allowed,
  children,
  title = "Upgrade to unlock",
  description = "This feature is available on a paid Kre8 plan.",
  cta = "View pricing",
  className = "",
}) {
  if (allowed) return children;

  return (
    <div
      className={`relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] p-5 backdrop-blur-xl sm:p-6 ${className}`}
      style={{
        boxShadow: "0 10px 40px rgba(0,0,0,0.35)",
      }}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute -right-12 -top-16 h-40 w-40 rounded-full opacity-25 blur-3xl"
        style={{ background: GREEN }}
      />
      <div className="relative">
        <div
          className="mb-4 grid h-11 w-11 place-items-center rounded-2xl"
          style={{
            background: `${GREEN}18`,
            border: `1px solid ${GREEN}55`,
            color: GREEN,
          }}
        >
          <LockKeyhole className="h-5 w-5" />
        </div>
        <h3 className="text-base font-bold text-white">{title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-zinc-400">{description}</p>
        <Link
          to="/pricing"
          className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.05] px-4 py-2.5 text-sm font-semibold text-white transition hover:border-white/25 hover:bg-white/[0.08]"
        >
          {cta}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
